var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEqSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#294222;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158.5,95.6c7.1-32.3-13.4-64.3-45.7-71.4S48.4,37.6,41.4,69.9s13.4,64.3,45.7,71.4 c30,6.6,60.1-10.6,69.7-39.7h-28.4c-10.4,15.7-31.4,20-47.1,9.6c-5.8-3.8-10.2-9.3-12.8-15.7H158.5z M68.7,69.6 c7.4-17.3,27.3-25.3,44.6-18c8.1,3.4,14.5,9.9,18,18H68.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M168.1,82.6v0.3c-0.4,37.6-31.2,67.8-68.8,67.4c-37-0.4-67-30.3-67.4-67.4v-0.3H5.7v0.3 c0,52.1,42.2,94.3,94.3,94.3s94.3-42.2,94.3-94.3v-0.3H168.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqSymbol);
export default __webpack_public_path__ + "static/media/eq-symbol.91e2fabaad0fecba2d40130701ff00bf.svg";
export { ForwardRef as ReactComponent };